import { useQuery } from '@tanstack/react-query';
import api from '@/libs/axiosInstance';

const fetchUnseenMentionsCount = async (): Promise<number> => {
  const response = await api.get<{ data: { count: number } }>('/dashboard/mentions/unseen-count');
  return response.data.data.count;
};

export const useUnseenMentionsCountQuery = () => {
  return useQuery({
    queryKey: ['mentions', 'unseen-count'],
    queryFn: fetchUnseenMentionsCount,
    refetchInterval: 60000,
  });
};
